module.exports = __webpack_public_path__ + "static/knotkova-d3868ae30b20be99c4f53046fbaac692.jpg";